import { BridgeAPI } from '../bridge'

const Accounts = {
  state: {
    maxAccounts: 5,

    counter: 0,
    accounts: [],
    targetAccount: {},
  },
  getters: {
    maxAccounts: state => state.maxAccounts,
    whereUsername: (state) => username => state.accounts.find(user => user.username === username),
    activeAccount: state => state.accounts.find(acc => acc.active),
    allAccounts: state => state.accounts.filter(account => !account.removed),
    targetAccount: state => state.targetAccount,
  },
  mutations: {

    setAccounts: (state, accounts) => state.accounts = accounts,
    setActive: (state) => {
      let check = state.accounts.find(acc => acc.active)
      state.activeAccount =  check ? check : (state.accounts ? state.accounts[0] : null)
    },
    setActiveAccount: (state, userId) => {
      let check = state.accounts.find(acc => acc.user_id === userId)
      if (check) {
        state.activeAccount = check;
      } else {
        if (!state.activeAccount) {
          state.activeAccount = state.accounts ? state.accounts[0] : null;
        }
      }
    },
    setTargetAccount: (state, userId) => {
      let check = state.accounts.find(acc => acc.user_id === userId)
      if (check) {
        state.targetAccount = check;
      } else {
        if (!state.activeAccount) {
          state.targetAccount = state.accounts ? state.accounts[0] : null;
        }
      }
    }
  },
  actions: {

    setActiveAccountByUserId: ({ commit }, userId) => commit('setActiveAccount', userId),
    loadAccounts: async ({ commit }) => {
      let accounts = await BridgeAPI.getAllAccounts();
      accounts.map((a) => {
        let copy = {...a};
        if (copy.password) delete copy.password;
        return copy;
      }).filter((a) => !a.removed && a.active);
      if (accounts && accounts.length) {
        let active = accounts.find(acc => acc.active && !acc.removed)
        if (active === undefined) {
          accounts[0].active = true;
        }
        commit('setAccounts', accounts.filter(acc => !acc.removed))
        commit('setActive');
      } else {
        commit('setAccounts', []);
        commit('setActive');
      }
    },
    setTargetAccount: ({ commit }, userId) => commit('setTargetAccount', userId),
  },
}

export {
  Accounts
} 